<template>
<div class="Login">
  <div class="login-container copyright-h row align-items-center justify-content-center" v-title data-title="登录">
    <div class="login-info">
      <div class="fc-white font-bold pb9 fs7">
        {{companyName || '登录'}}
      </div>
      <div class="row align-items-center login-item">
        <div class="login-label">账户</div>
        <div class="login-line"></div>
        <input class="login-input flex-1" v-model="username" type="text" placeholder="请输入账户">
      </div>
      <div class="row align-items-center login-item mt7">
        <div class="login-label">密码</div>
        <div class="login-line"></div>
        <input class="login-input flex-1" v-model="password" type="password" placeholder="请输入密码">
      </div>
      <div class="login-box">
        <van-button class="btn-primary" type="info"
          :loading="loading" loading-text="登录中..."
          @click="login">登 录</van-button>
      </div>
    </div>
  </div>
  <div class="copyright">
    <a style="color: #c1c1c1;" target="_blank" href="http://beian.miit.gov.cn">沪ICP备19025713号-1</a>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { Base64 } from 'js-base64';
// eslint-disable-next-line import/no-cycle
import { sendRequest, login, getLoginInfo } from '../network/NetworkAccessor';
import storage from '../uitls/cacheUtil';

export default Vue.extend({
  name: 'Login',
  components: {},
  props: {
    companyIdStr: { // companyIdStr,处理后的合作单位id(处理规则：base64(`_${companyId}`))
      type: String,
      default: '',
    },
  },
  data() {
    return {
      username: '',
      password: '',
      checked: true,
      loading: false,
      companyName: '',
      // name: '',
      companyId: '',
    };
  },
  methods: {
    login() {
      if (!this.username || !this.password) {
        this.$dialog.alert({
          message: '请输入用户名密码',
        });
        return;
      }
      this.loading = true;
      sendRequest(login, {
        username: this.username,
        password: this.password,
      }).then((res = {}) => {
        // console.log(res);
        storage.local.set('token', res.token || '');
        storage.local.set('type', res.type);
        // if (res.type === 1) {
        //   this.$router.replace('/home');
        // } else if (res.type === 2 || res.type === 4) { // 1 管理员 2 报价商 3 测试 4 生产的测试用户
        //   this.$router.replace('/quotation/edit');
        // } else if (res.type === 3) {
        //   this.$router.replace('/login/success');
        // }
        if (res.type === 4) {
          this.$router.replace('/login/success');
        } else {
          this.$router.replace('/home');
        }
      }).catch((e = {}) => {
        this.$dialog.alert({
          message: (e || {}).message || '登录失败，请检查用户名密码',
        });
        // console.log(e);
      }).then(() => {
        this.loading = false;
      });
    },
    getLoginInfo() {
      sendRequest(getLoginInfo, { userId: this.companyId }).then((res = {}) => {
        this.companyName = res.companyName;
        this.username = res.username;
      });
    },
  },
  created() {
    storage.session.set('BLACK_PARAMS', {});
    storage.session.set('BLACK_ITEM', {});
    storage.session.set('BLACK_ITEM', {});
    storage.local.set('M_L', []);
    storage.local.set('C_ID', '');
    if (this.companyIdStr) {
      const [sign, companyId] = Base64.decode(this.companyIdStr).split('_');
      if (sign) {
        this.$router.push('/404');
        return;
      }
      storage.local.set('C_ID', companyId || '');
      if (!companyId) {
        return;
      }
      this.companyId = companyId;
      this.getLoginInfo();
    }
  },
});
</script>
<style scoped>
.Login {
  background-image: url('../assets/bg2.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.login-container {
  min-height: 100vh;
}
.login-item {
  padding: 10px 15px;
  border-radius: 6px;
  background-color: #ffffff;
}
.login-label {
  padding-right: 15px;
  color: #8a959e;
}
.login-line {
  height: 25px;
  border-left: 1px solid #aab0b5;
  padding-right: 5px;
}
.login-input {
  padding: 5px 5px 5px 10px;
  border-radius: 6px;
  outline:none;
  border: 0;
  background-color: #ffffff!important;
  width: 100%;
}
input:focus{
  border: 0;
  background-color: #ffffff!important;
}
.login-box {
  padding-top: 50px;
}
.login-info {
  height: calc(100vh - 180px);
  min-height: 50vh;
  max-height: 450px;
  width: 80%;
  background-image: linear-gradient(to bottom right, #2027ac, #fbfbff);
  border-radius: 16px;
  padding: 50px 25px;
  opacity: 0.94;
}
.btn-login {
  border-radius: 24px;
  width: 80%;
  background-color: #2027ac;
  border: 0;
  font-size: 17px;
}
</style>
